module.exports = __webpack_public_path__ + "media/m2.72c2ffb2.mp4";